<template>
  <div>
    <editor
      v-if="active"
      cloud-channel="6"
      @onBlur="handleBlur"
      @onFocus="$emit('clickTriggered')"
      @onFocusOut="onFocusOut"
      :disabled="disabled"
      :apiKey="apiKey"
      v-model="localValue"
      model-events="input keyup redo ExecCommand undo paste blur"
      :init="config"
      :id="id"
    >
    </editor>
  </div>
</template>
<script>
  import Editor from '@tinymce/tinymce-vue';

  export default {
    name: 'app',

    name: 'tiny-mce',

    data() {
      return {
        active: true,
        apiKey: 's3gkqh1g7a55pl75k1629ned1uf5ct80f96zjfy2gb57q1qi',
        skillsOrScenarioPage:
          'bold italic underline | link | image | media | table | bullist | numlist | indent | outdent | fontsize | fontfamily | charmap | codesample | undo | redo | removeformat',
        emailEditMode:
          'bold italic underline | link | image | media | table | bullist | numlist | indent | outdent | fontsize | fontfamily | styles | charmap | codesample | undo redo | removeformat',
        imEditMode: 'bold italic underline | link | bullist | numlist | image',
        participantFeedback:
          'bold italic underline | link | image | table bullist numlist  indent  outdent  codesample  undo redo removeformat fullscreen',
        writtenResponse:
          'bold italic underline | link | media | table | bullist | numlist | indent | outdent | codesample | removeformat',
        defaultToolbar:
          'bold italic underline | link | table |  bullist | numlist | image | undo redo| fontsize | indent | outdent',
        toolbar_groups: {
          additional: {
            icon: 'more-drawer',
            tooltip: 'More Options',
            items: 'bullist numlist outdent indent',
          },
        },
      };
    },

    props: {
      id: {
        type: String,
        required: false,
      },
      value: {
        type: String,
        required: true,
      },

      height: {
        type: String,
        default: '220',
        required: false,
      },

      onFocusOut: {
        type: Function,
        required: false,
        default: function () {
          return () => {};
        },
      },

      placeholder: {
        type: String,
        required: false,
        default: '',
      },

      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },

      configOverrides: {
        type: Object,
        default: () => ({}),
      },

      isInlineMode: {
        type: Boolean,
        default: false,
      },
      isSkillOrScenarioPage: {
        type: Boolean,
        default: false,
      },
      isEditMode: {
        type: Boolean,
        default: false,
      },
      isIm: {
        type: Boolean,
        default: false,
      },
      isParticipantFeedback: {
        type: Boolean,
        default: false,
      },
      isWrittenResponse: {
        type: Boolean,
        default: false,
      },
    },

    methods: {
      onInit() {
        // Emits the event so that Cypress knows when to begin TinyMCE assertions

        const event = new Event('tinymceLoaded');

        document.dispatchEvent(event);
      },

      handleBlur() {
        this.$emit('blur', this.localValue);
      },
    },

    components: {
      editor: Editor,
    },

    deactivated() {
      this.active = false;
    },

    activated() {
      this.active = true;
    },

    computed: {
      computedHeight() {
        return this.height || '20vh';
      },

      plugins() {
        const defaultPlugins = [
          'advlist',
          'autolink',
          'lists',
          'link',
          'image',
          'charmap',
          'visualblocks',
          'fullscreen',
          'preview',
          'insertdatetime',
          'media',
          'table',
          'wordcount',
          'codesample',
        ];
        if (this.isInlineMode) {
          return [...defaultPlugins, 'quickbars'];
        }
        return defaultPlugins;
      },

      styles() {
        const defaultStyles = `
          @import url('https://fonts.googleapis.com/css2?family=Lato:wght@900&family=Roboto:wght@300;400;700&display=swap');
          body {
            font-size: 14px;
            font-family: 'Roboto', sans-serif;
          }
         
        `;
        // Only for Answer.vue
        if (this.isInlineMode) {
          const inlineStyle = `.mce-content-body::before {
                                left: inherit !important;
                                margin-left: 10px;
                              }
                              .mce-content-body {
                                margin: 0;
                              } p,h2,h3::before {
                                margin: 5px 0 2px 10px;
                              } p,h2,h3 { margin: 5px 0 2px 10px;}
                              `;
          return defaultStyles + inlineStyle;
        }
        return defaultStyles;
      },

      config() {
        if (this.isSkillOrScenarioPage) {
          this.defaultToolbar = this.skillsOrScenarioPage;
        } else if (this.isEditMode && !this.isIm) {
          // edit email mode
          this.defaultToolbar = this.emailEditMode;
        } else if (this.isEditMode && this.isIm) {
          // edit IM mode
          this.defaultToolbar = this.imEditMode;
        } else if (this.isParticipantFeedback) {
          this.defaultToolbar = this.participantFeedback;
        } else if (this.isWrittenResponse) {
          this.defaultToolbar = this.writtenResponse;
        }

        const defaultConfig = {
          placeholder: this.placeholder,
          content_style: this.styles,
          height: this.computedHeight,
          menubar: false,
          plugins: this.plugins,
          toolbar: this.defaultToolbar,
          font_family_formats: `Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats; Roboto=Roboto, sans-serif`,
          toolbar_groups: this.toolbar_groups,
          branding: false,
          statusbar: false,
          convert_urls: false,
          link_assume_external_targets: true,
          paste_data_images: true,
          setup: (editor) => {
            editor.on('activate', this.onInit);
          },
        };
        // Only for Answer.vue
        if (this.isInlineMode) {
          return {
            ...defaultConfig,
            toolbar: false,
            menubar: false,
            inline: false,
            inline_boundaries: false,
            quickbars_insert_toolbar: false,
            quickbars_selection_toolbar: 'bold italic | h2 h3 blockquote',
            skin: 'tinymce-5',
            min_height: 53,
            ...this.configOverrides,
          };
        }
        return {
          ...defaultConfig,
          skin: 'tinymce-5',
          ...this.configOverrides,
        };
      },

      localValue: {
        get() {
          return this.value;
        },

        set(val) {
          this.$emit('input', val);
        },
      },
    },
  };
</script>
